import { RootState } from "@store/reducers";
import { PencilLine } from "lucide-react";
import { useSelector } from "react-redux";

const ProfileSection = () => {
  const user = useSelector((state: RootState) => state.auth.user);

  return (
    <div className="flex rounded-xl bg-white w-full p-6 border justify-between">
      <div className="flex items-center gap-5">
        <div className="flex items-center justify-center rounded-full bg-gray-200 h-24 w-24 overflow-hidden border">
          {user?.profilePic ? (
            <img src={user?.profilePic} className="h-full w-full" />
          ) : (
            <span className="font-bold text-4xl">
              {user?.firstName?.charAt(0)}
              {user?.lastName?.charAt(0)}
            </span>
          )}
        </div>
        <div className="flex flex-col gap-1">
          <span className="uppercase font-bold text-3xl text-slate-800">
            {user?.firstName} {user?.lastName}
          </span>
          <span className="font-medium text-light-black">Aspirations</span>
          <span className="text-xs font-medium text-light-black">
            {user?.location || "N/A"}
          </span>
        </div>
      </div>

      <div className="flex flex-col items-end gap-5">
        <span className="italic text-xs">Last updated: October 2025</span>
        <button className="flex items-center gap-2 rounded-md border py-2 px-3">
          <PencilLine size={16} color="#334154" />
          <span className="text-slate-800 font-bold text-xs">Edit Profile</span>
        </button>
      </div>
    </div>
  );
};

export default ProfileSection;
